const EditIcon = ({
  size = 16,
  color = "#6A7282",
  strokeWidth = 1.333,
  isActive = false,
}) => {
  const activeColor = isActive ? "#dc2626" : color;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_edit)">
        <path
          d="M14.116 4.54132C14.4685 4.18894 14.6666 3.71097 14.6666 3.21256C14.6667 2.71415 14.4687 2.23613 14.1164 1.88366C13.764 1.53118 13.286 1.33313 12.7876 1.33307C12.2892 1.33301 11.8112 1.53094 11.4587 1.88332L2.56136 10.7827C2.40657 10.937 2.2921 11.127 2.22803 11.336L1.34736 14.2373C1.33013 14.295 1.32883 14.3562 1.34359 14.4146C1.35836 14.4729 1.38864 14.5261 1.43123 14.5687C1.47381 14.6112 1.52711 14.6414 1.58547 14.656C1.64383 14.6707 1.70507 14.6693 1.76269 14.652L4.66469 13.772C4.87347 13.7085 5.06348 13.5947 5.21803 13.4407L14.116 4.54132Z"
          stroke={activeColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_edit">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EditIcon;
